import * as React from "react";

const SvgWarningIconOnly = (props) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.814 20.647 15.378 5.378c-.76-1.227-1.996-1.23-2.756 0l-9.436 15.27c-1.02 1.648-.28 2.977 1.651 2.977h18.326c1.928 0 2.669-1.332 1.651-2.978ZM14 21a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75Zm.875-4.372A.877.877 0 0 1 14 17.5a.872.872 0 0 1-.875-.872v-5.256c0-.476.391-.872.875-.872.487 0 .875.391.875.872v5.256Z"
      fill="#242424"
    />
  </svg>
);

export default SvgWarningIconOnly;
